<template lang="pug">
  div
    el-row.margin-top-20(
      :gutter="20"
      v-for="(line, index) in lines"
      :key="index"
    )
      i(class="el-icon-data-line lineLabel" style="font-size: 1.35em")
      span(class="lineLabel") Line {{ index + 1 }}
      el-button.margin-left-15(
        type="danger"
        size="mini"
        icon="el-icon-document-delete"
        @click="removeLine(index)"
      ) Remove

      el-form(
        :model="line"
        :rules="rules"
        inline=true
        label-width="8vw"
        ref="form-criteria"
      )
        el-row.margin-top-10
          el-col(:span="1") &nbsp;
          el-col(:span="14")
            el-form-item(prop="xData.value")
              span(slot="label" class="fieldLabel") X Data
              el-input(
                v-model="line.xData.value"
                size="small"
                @change="updatePts('xData',index)"
                placeholder="[1, 2, 3] or 1:3")
          el-col(:span="9")
            el-form-item(prop="xData.score")
              span(class="fieldLabel") Pts
              el-input-number(v-model="line.xData.score" :step="1" :min="0" size="small")
        
        el-row.margin-top-10
          el-col(:span="1") &nbsp;
          el-col(:span="14")
            el-form-item(prop="yData.value")
              span(slot="label" class="fieldLabel") Y Data
              el-input(
                v-model="line.yData.value"
                size="small"
                @change="updatePts('yData',index)"
                placeholder="[1, 2, 3] or 1:3")

          el-col(:span="9")
            el-form-item(prop="yData.score")
              span(class="fieldLabel") Pts
              el-input-number(v-model="line.yData.score" :step="1" :min="0" size="small")

        el-row.margin-top-10
          el-col(:span="1") &nbsp;
          el-col(:span="14")
            el-form-item(prop="style.value")
              span(slot="label" class="fieldLabel") Style
              el-input(
                v-model="line.style.value"
                size="small"
                @change="updatePts('style',index)"
                placeholder=":, -, --, or -.")

          el-col(:span="9")
            el-form-item(prop="style.score")
              span(class="fieldLabel") Pts
              el-input-number(v-model="line.style.score" :step="1" :min="0" size="small")

        el-row.margin-top-10
          el-col(:span="1") &nbsp;
          el-col(:span="14")
            el-form-item(prop="marker.value")
              span(slot="label" class="fieldLabel") Marker
              el-input(
                v-model="line.marker.value"
                size="small"
                @change="updatePts('marker',index)"
                placeholder="+, o, *, x, etc.")

          el-col(:span="9")
            el-form-item(prop="marker.score")
              span(class="fieldLabel") Pts
              el-input-number(v-model="line.marker.score" :step="1" :min="0" size="small")

        el-row.margin-top-10
          el-col(:span="1") &nbsp;
          el-col(:span="14")
            el-form-item(prop="color.value")
              span(slot="label" class="fieldLabel") Color
              el-input(
                v-model="line.color.value"
                size="small"
                @change="updatePts('color',index)"
                placeholder="r or [1,0,0]")

          el-col(:span="9")
            el-form-item(prop="color.score")
              span(class="fieldLabel") Pts
              el-input-number(v-model="line.color.score" :step="1" :min="0" size="small")

    el-button.margin-top-20(
      type="primary"
      icon="el-icon-plus"
      size="small"
      @click="addLine"
    ) Add Line


</template>

<script>
  import capitalize from 'lodash/capitalize'

  export default {
    props: {
      lines: {
        type: Array,
        required: true,
      },
    },

    data() {
      return {
        rules : {
          xData: {
            value: [{ param: 'xData', type: 'number', validator: this.validateValues }],
            score: [{ param: 'xData', type: 'number', validator: this.validateScores }],
          },
          yData: {
            value: [{ param: 'yData', type: 'number', validator: this.validateValues }],
            score: [{ param: 'yData', type: 'number', validator: this.validateScores }],
          },
          style: {
            value: [{ param: 'style', type: 'number', validator: this.validateValues }],
            score: [{ param: 'style', type: 'number', validator: this.validateScores }],
          },
          marker: {
            value: [{ param: 'marker', type: 'number', validator: this.validateValues }],
            score: [{ param: 'marker', type: 'number', validator: this.validateScores }],
          },
          color: {
            value: [{ param: 'color', type: 'number', validator: this.validateValues }],
            score: [{ param: 'color', type: 'number', validator: this.validateScores }],
          },
        },
      }
    },

    mounted() {
      if (!this.lines.length) {
        this.addLine()
      }
    },

    methods: {
      addLine() {
        this.lines.push({
          xData: {
            value: '',
            score: 0,
          },
          yData: {
            value: '',
            score: 0,
          },
          style: {
            value: '',
            score: 0,
          },
          marker: {
            value: '',
            score: 0,
          },
          color: {
            value: '',
            score: 0,
          },
        })
      },

      removeLine(index) {
        this.lines.splice(index, 1)
      },

      updatePts(param, index) {
        if (this.lines[index][param].value && !this.lines[index][param].score) {
          this.lines[index][param].score = 1
        }
      },

      // TO-DO: Validation checks are rendered in ALL lines and can not pinpoint which specific line data has issue
      // However, let's retain this form of check than not having any at all
      validateValues(rule, value, callback) {
        this.lines.forEach(line => {
          if (line[rule.param].score > 0 && !line[rule.param].value) {
            callback(new Error(`${capitalize(rule.param)} is required`))
          } else {
            callback()
          }
        })
      },

      validateScores(rule, value, callback) {
        this.lines.forEach(line => {
          if (line[rule.param].value && line[rule.param].score <= 0) {
            callback(new Error('Score is required'))
          } else {
            callback()
          }
        })
      },

      validateAll() {
        let isValid = true
        for (const form of this.$refs['form-criteria']) {
          form.validate(valid => {
            isValid = isValid && valid
          })
        }
        return isValid
      },
    },
  }
</script>

<style scoped>
  .lineLabel {
    font-size: 1em;
    padding-left: 10px;
  }
  .el-input {
    min-width: 28vw;
  }
  .fieldLabel {
    margin-right: 1vw;
    font-size: 1em;
    font-weight: 200;
    color: #757575;
  }
</style>
